
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9ca4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9ca4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8Ukbq", function(module, exports) {

$parcel$export(module.exports, "HexCell", () => $a9a047315ee67aa4$export$8d2bf70a06726ba6);

var $7WQrb = parcelRequire("7WQrb");

var $800sp = parcelRequire("800sp");

var $4OBpG = parcelRequire("4OBpG");

var $jbRid = parcelRequire("jbRid");

var $eCzHl = parcelRequire("eCzHl");

var $ca3Iw = parcelRequire("ca3Iw");
class $a9a047315ee67aa4$export$8d2bf70a06726ba6 extends (0, $800sp.LitElement) {
    static{
        this.properties = {
            showInnerBorder: {
                type: Boolean,
                reflect: true
            },
            showAnimations: {
                type: Boolean,
                reflect: true
            },
            isSpecialFilterOn: {
                type: Boolean,
                reflect: true
            }
        };
    }
    static{
        this.styles = (0, $800sp.css)`
        :host {
            display: block;
        }
        .hex-container {
            position: relative;
            font-size: var(--font-size, 2.8cqh);
            height: 100%;
            aspect-ratio: 866 / 1000; /* Using the ratio derived from sqrt(3)/2 */
        }
        .hex {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            aspect-ratio: 866 / 1000; /* Using the ratio derived from sqrt(3)/2 */
            width: calc(100% - 4px); /* Reduce width to accommodate border */
            height: calc(100% - 4px); /* Reduce height to accommodate border */
            clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
            color: var(--body-color);
            background-color: var(--hex-choice-color-override, var(--background-color));
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: background-color 0.3s ease;
            user-select: none;
        }
        .hex-value {
            z-index: 2;
        }
        .hex-value:hover, .hex-inner-border:hover {
            background-color: var(--hover-color);
        }
        .hex-background {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width: calc(100% + var(--hex-border-increase, 4px));
            height: calc(100% + var(--hex-border-increase, 4px));
            background-color: var(--body-color);
        }
        .hex-inner-border {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width: 70%;
            height: 70%;
            background-color: var(--hex-inner-border-color);
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .disabled {
            cursor: default !important;
            background-color: var(--background-color-disabled) !important;
        }
        .disabled:hover {
            background-color: var(--background-color-disabled) !important;
        }
        .hex-inner-border-disabled:hover {
            background-color: var(--hex-inner-border-color) !important;
        }
        .hex-pencils-left {
            position: absolute;
            height: fit-content;
            width: fit-content;
            display: flex;
            flex-direction: column;
            margin: 0;
            padding: 0;
            top: 24%;
            left: 0.22em;
            overflow: hidden;
        }
        
        .hex-pencils-right {
            position: absolute;
            height: fit-content;
            width: fit-content;
            display: flex;
            flex-direction: column;
            margin: 0;
            padding: 0;
            top: 24%;
            right: 0.22em;
            overflow: hidden;
        }
        .hex-pencil-top {
            position: absolute;
            height: fit-content;
            width: fit-content;
            display: flex;
            flex-direction: column;
            margin: 0;
            padding: 0;
            top: 0%;
            margin-top: 0.22em;
            overflow: hidden;
            left: 50%;
            transform: translateX(-50%);
        }
        .hex-pencil-bottom {
            position: absolute;
            height: fit-content;
            width: fit-content;
            display: flex;
            flex-direction: column;
            margin: 0;
            padding: 0;
            bottom: 0%;
            margin-bottom: 0.22em;
            overflow: hidden;
            left: 50%;
            transform: translateX(-50%);
        }
        .hex-pencil-mark {
            margin: 0;
            width: fit-content;
            font-size: calc(var(--font-size, 2.8cqh) * 0.4) !important;
        }
        p {
            margin: 0;
            padding: 0;
        }
        :host([showInnerBorder]) .hex-inner-border,
        :host([isSpecialFilterOn]) .hex-inner-border {
            display: flex;
            z-index: 1;
        }
        :host([showAnimations]) .pulse-once {
            animation: pulse 0.4s ease forwards;
        }    
        /* Animation to grow and shrink */
        @keyframes pulse {
            0%, 100% {
                transform: scale(1);
            }
            50% {
                transform: scale(1.3);
            }
        }
    `;
    }
    get disabled() {
        return this.isDisabled;
    }
    set disabled(is) {
        if (this.isDisabled === is) return;
        if (is) this.setAttribute("disabled", "true");
        else this.removeAttribute("disabled");
        this.isDisabled = is;
        this.requestUpdate();
    }
    constructor(){
        super();
        this.clientService = (0, $ca3Iw.ComponentDependencyTree).clientService;
        this.value = "";
        this.mode = "vertical";
        this.pencils = new Set();
        this.row = 0;
        this.col = 0;
        this.cellValueType = (0, $eCzHl.CellValueType).standard;
        this.showInnerBorder = false;
        this.showAnimations = true;
        this.isSpecialFilterOn = false;
        this.clickContextEventDefer = false;
        this.clickContextDoDispatch = false;
        this.firstOfDoubleLeftClick = false;
        this.resizeThrottleAwait = Promise.resolve();
        this.isResizeThrottleWaiting = false;
        this.lastContainerHeight = 0;
        this.pencilsOverflowing = false;
        this.leftRightDelay = 120;
        this.numPencilInLeftVisible = this.clientService.getConfig().gameBoard.hexCell.numPencilsVisible;
        this.isDisabled = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.id = `hex-${this.row}-${this.col}`;
        if (this.onConnected) this.onConnected(this);
        this.setupLeftRightClickListeners();
    }
    firstUpdated() {
        const container = this.shadowRoot.querySelector(".hex-container");
        const pencilsLeft = this.shadowRoot.querySelector(".hex-pencils-left");
        if (container && pencilsLeft) {
            this.resizeObserver = new ResizeObserver(()=>{
                this.checkPencilsLeftHeight(container, pencilsLeft);
            });
            this.resizeObserver.observe(container);
            this.resizeObserver.observe(pencilsLeft);
            // Initial check
            this.checkPencilsLeftHeight(container, pencilsLeft);
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        // Check if the "disabled" attribute is present
        this.disabled = this.hasAttribute("disabled") && this.getAttribute("disabled") !== "false";
    }
    setupLeftRightClickListeners() {
        this.clickListener = this.addEventListener("click", (e)=>{
            // @ts-ignore
            if (e._hexAllowDispatch) return true;
            if (this.firstOfDoubleLeftClick) {
                this.dispatchEvent(new CustomEvent("double-click", {
                    // @ts-ignore
                    target: this
                }));
                this.clickContextEventDefer = false;
                this.clickContextDoDispatch = false;
                this.firstOfDoubleLeftClick = false;
            } else if (this.clickContextEventDefer) {
                this.dispatchEvent(new CustomEvent("left-right-click", {
                    // @ts-ignore
                    target: this
                }));
                this.clickContextEventDefer = false;
                this.clickContextDoDispatch = false;
                this.firstOfDoubleLeftClick = false;
            } else {
                this.clickContextDoDispatch = true;
                this.clickContextEventDefer = true;
                this.firstOfDoubleLeftClick = true;
                setTimeout(()=>{
                    if (this.clickContextDoDispatch) {
                        this.clickContextEventDefer = false;
                        const newEvent = new Event("click", e);
                        // @ts-ignore
                        newEvent._hexAllowDispatch = true;
                        this.dispatchEvent(newEvent);
                        this.clickContextDoDispatch = false;
                    }
                    this.firstOfDoubleLeftClick = false;
                }, this.leftRightDelay);
            }
            // prevent from bubbling up
            e.stopPropagation();
            e.preventDefault();
        }, {
            passive: false,
            capture: true
        });
        if (this.clientService.getConfig().gameBoard.hexCell.rightClickStrategy === "contextmenu") this.contextMenuListener = this.addEventListener("contextmenu", (e)=>{
            console.debug(`[HexCell] context menu`);
            // @ts-ignore
            if (e._hexAllowDispatch) return true;
            if (this.clickContextEventDefer) {
                this.dispatchEvent(new CustomEvent("left-right-click", {
                    // @ts-ignore
                    target: this
                }));
                this.clickContextEventDefer = false;
                this.clickContextDoDispatch = false;
                this.firstOfDoubleLeftClick = false;
            } else {
                this.clickContextDoDispatch = true;
                this.clickContextEventDefer = true;
                this.firstOfDoubleLeftClick = false;
                setTimeout(()=>{
                    if (this.clickContextDoDispatch) {
                        this.clickContextEventDefer = false;
                        const newEvent = new Event("contextmenu", e);
                        // @ts-ignore
                        newEvent._hexAllowDispatch = true;
                        this.dispatchEvent(newEvent);
                        this.clickContextDoDispatch = false;
                    }
                    this.firstOfDoubleLeftClick = false;
                }, this.leftRightDelay);
            }
            // prevent from bubbling up
            e.stopPropagation();
            e.preventDefault();
        }, {
            passive: false,
            capture: true
        });
        else {
            // Set up long-press detection logic
            let pressTimer;
            this.addEventListener("pointerdown", (e)=>{
                startPressTimer(e);
            });
            this.addEventListener("pointerup", ()=>{
                clearPressTimer();
            });
            this.addEventListener("pointerleave", ()=>{
                clearPressTimer(); // Ensure timer is cleared when pointer leaves the element
            });
            this.addEventListener("pointercancel", ()=>{
                clearPressTimer(); // Handle interrupted interactions
            });
            const that = this;
            function startPressTimer(e) {
                clearPressTimer(); // Ensure no timer is running
                // Start a 2-second timer to detect long-press
                pressTimer = window.setTimeout(()=>{
                    that.clickContextEventDefer = false;
                    const newEvent = new Event("contextmenu", e);
                    // @ts-ignore
                    newEvent._hexAllowDispatch = true;
                    that.dispatchEvent(newEvent);
                    that.clickContextDoDispatch = false;
                }, 1100);
            }
            function clearPressTimer() {
                if (pressTimer !== undefined) {
                    clearTimeout(pressTimer);
                    pressTimer = undefined;
                }
            }
        }
    }
    addPencil(mark) {
        this.pencils.add(mark);
        this.requestUpdate();
    }
    removePencil(mark) {
        this.pencils.delete(mark);
        this.requestUpdate();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("click", this.clickListener);
        this.removeEventListener("contextmenu", this.contextMenuListener);
    }
    _emitLeftRightClicked() {
        this.dispatchEvent(new CustomEvent("left-right-click", {
            detail: {
                target: this
            },
            bubbles: true,
            composed: true
        }));
    }
    displayInnerBorder() {
        this.showInnerBorder = true;
    }
    hideInnerBorder() {
        this.showInnerBorder = false;
    }
    displayAnimations() {
        this.showAnimations = true;
    }
    hideAnimations() {
        this.showAnimations = false;
    }
    /**
     * Apply the pulse animation once
     */ pulse() {
        const hexElement = this.shadowRoot.querySelector(".hex-container");
        hexElement.classList.add("pulse-once");
        hexElement.style.zIndex = "50";
        this.style.zIndex = "50";
        this.parentElement.style.zIndex = "50";
        const removeAnimation = ()=>{
            hexElement.classList.remove("pulse-once");
            hexElement.removeEventListener("animationend", removeAnimation);
            hexElement.style.zIndex = "initial";
            this.style.zIndex = "initial";
            this.parentElement.style.zIndex = "initial";
        };
        hexElement.addEventListener("animationend", removeAnimation);
    }
    showSpecialFilter() {
        this.isSpecialFilterOn = true;
    }
    hideSpecialFilter() {
        this.isSpecialFilterOn = false;
    }
    render() {
        const pencils = [
            ...this.pencils
        ].sort((a, b)=>{
            return parseInt(a, 16) - parseInt(b, 16);
        }).map((value)=>(0, $jbRid.HexakaiCellValueMapper).getValue(value, this.cellValueType));
        const n = this.numPencilInLeftVisible;
        const concatPad = [
            "-"
        ];
        for(let i = 1; i < n; i++)concatPad.push("-");
        const pencilTop = pencils.slice(0, 1);
        const pencilsLeft = pencils.slice(1, 1 + n).concat(concatPad).slice(0, n);
        const pencilsRight = pencils.slice(1 + n, 1 + 2 * n).concat(concatPad).slice(0, n);
        const pencilBottom = pencils.length > 2 + 2 * n || this.pencilsOverflowing && pencils.length > 0 ? "+" : pencils.length === 2 + 2 * n ? pencils[1 + 2 * n] : "";
        const hidden = this.pencilsOverflowing ? "visibility: hidden;" : "";
        const dV = (0, $jbRid.HexakaiCellValueMapper).getValue(this.value, this.cellValueType);
        return (0, $800sp.html)`
            <div class="hex-container">
                <div class="hex hex-background"></div>
                <div class="hex hex-inner-border ${this.isDisabled ? "hex-inner-border-disabled" : ""}">
                    <p>${dV}</p>
                </div>
                <div class="hex ${this.isDisabled ? "disabled" : ""}">
                    <p>${dV}</p>
                </div>
                <div class="hex-pencils-left">
                    ${pencilsLeft.map((mark)=>{
            const isHidden = this.pencilsOverflowing || mark === "-";
            const hiddenStyle = isHidden ? "visibility: hidden;" : "";
            return (0, $800sp.html)`<div class="hex-pencil-mark" style="${hiddenStyle}">${mark}</div>`;
        })}
                </div>
                <div class="hex-pencils-right">
                    ${pencilsRight.map((mark)=>{
            const isHidden = this.pencilsOverflowing || mark === "-";
            const hiddenStyle = isHidden ? "visibility: hidden;" : "";
            return (0, $800sp.html)`<div class="hex-pencil-mark" style="${hiddenStyle}">${mark}</div>`;
        })}
                </div>
                <div class="hex-pencil-top">
                    <div class="hex-pencil-mark" style="${hidden}">${pencilTop}</div>
                </div>
                <div class="hex-pencil-bottom">
                    <div class="hex-pencil-mark">${pencilBottom}</div>
                </div>
            </div>
        `;
    }
    async checkPencilsLeftHeight(container, pencilsLeft, tryIncrement = true) {
        // wait for throttle
        if (this.isResizeThrottleWaiting) return;
        this.isResizeThrottleWaiting = true;
        await this.resizeThrottleAwait;
        const containerHeight = container.offsetHeight;
        const pencilsLeftHeight = pencilsLeft.offsetHeight;
        // Check if pencilsLeft has too much height
        const sizeMult = 0.55;
        const isOverflowing = pencilsLeftHeight > containerHeight * sizeMult;
        if (isOverflowing) {
            if (this.numPencilInLeftVisible > 2) //console.debug(`[HexCell] is overflowing, so decrementing num pencils visible`);
            this.numPencilInLeftVisible--;
            else this.pencilsOverflowing = true;
        } else {
            this.pencilsOverflowing = false;
            if (tryIncrement && containerHeight !== this.lastContainerHeight) requestAnimationFrame(()=>{
                //console.debug(`[HexCell] checking if we can increment num pencils visible`);
                this.numPencilInLeftVisible++;
                this.checkPencilsLeftHeight(container, pencilsLeft, false);
            });
        }
        this.isResizeThrottleWaiting = false;
        this.resizeThrottleAwait = new Promise((resolve)=>{
            setTimeout(resolve, 20);
        });
        this.lastContainerHeight = containerHeight;
        this.requestUpdate();
    }
}
(0, $7WQrb.__decorate)([
    (0, $4OBpG.property)({
        type: String
    })
], $a9a047315ee67aa4$export$8d2bf70a06726ba6.prototype, "value", void 0);
(0, $7WQrb.__decorate)([
    (0, $4OBpG.property)({
        type: String
    })
], $a9a047315ee67aa4$export$8d2bf70a06726ba6.prototype, "mode", void 0);
(0, $7WQrb.__decorate)([
    (0, $4OBpG.property)({
        type: Set
    })
], $a9a047315ee67aa4$export$8d2bf70a06726ba6.prototype, "pencils", void 0);
(0, $7WQrb.__decorate)([
    (0, $4OBpG.property)({
        type: Number
    })
], $a9a047315ee67aa4$export$8d2bf70a06726ba6.prototype, "row", void 0);
(0, $7WQrb.__decorate)([
    (0, $4OBpG.property)({
        type: Number
    })
], $a9a047315ee67aa4$export$8d2bf70a06726ba6.prototype, "col", void 0);
(0, $7WQrb.__decorate)([
    (0, $4OBpG.property)({
        type: (0, $eCzHl.CellValueType)
    })
], $a9a047315ee67aa4$export$8d2bf70a06726ba6.prototype, "cellValueType", void 0);
(0, $7WQrb.__decorate)([
    (0, $4OBpG.property)({
        attribute: false
    })
], $a9a047315ee67aa4$export$8d2bf70a06726ba6.prototype, "onConnected", void 0);
$a9a047315ee67aa4$export$8d2bf70a06726ba6 = (0, $7WQrb.__decorate)([
    (0, $4OBpG.customElement)("hex-cell")
], $a9a047315ee67aa4$export$8d2bf70a06726ba6);

});
parcelRegister("jbRid", function(module, exports) {

$parcel$export(module.exports, "HexakaiCellValueMapper", () => $d46b8efdd22e874f$export$b5278def529d8a51);

var $eCzHl = parcelRequire("eCzHl");
class $d46b8efdd22e874f$export$b5278def529d8a51 {
    static{
        this.standard = new Array(16).fill(0).map((_, ind)=>`${ind.toString(16).toUpperCase()}`);
    }
    static{
        this.numbersOnly = new Array(16).fill(0).map((_, ind)=>`${ind}`);
    }
    static{
        this.lettersOnly = new Array(16).fill(0).map((_, ind)=>String.fromCharCode("A".charCodeAt(0) + ind));
    }
    static{
        this.emojis = [
            "\uD83D\uDE00",
            "\uD83D\uDE02",
            "\uD83E\uDD14",
            "\uD83D\uDE0D",
            "\uD83D\uDE0E",
            "\uD83E\uDD29",
            "\uD83D\uDE0A",
            "\uD83D\uDE43",
            "\uD83D\uDE09",
            "\uD83E\uDD73",
            "\uD83D\uDE34",
            "\uD83E\uDD2F",
            "\uD83E\uDD78",
            "\uD83E\uDD20",
            "\uD83E\uDD7A",
            "\uD83D\uDE07"
        ];
    }
    static{
        this.greekAlphabet = [
            "\u03B1",
            "\u03B2",
            "\u03B3",
            "\u03B4",
            "\u03B5",
            "\u03B6",
            "\u03B7",
            "\u03B8",
            "\u03B9",
            "\u03BA",
            "\u03BB",
            "\u03BC",
            "\u03BD",
            "\u03BE",
            "\u03BF",
            "\u03C0"
        ];
    }
    static getValue(value, type) {
        if (!value) return value;
        switch(type){
            case (0, $eCzHl.CellValueType).numbersOnly:
                return this.numbersOnly[parseInt(value, 16)] ?? value;
            case (0, $eCzHl.CellValueType).lettersOnly:
                return this.lettersOnly[parseInt(value, 16)] ?? value;
            case (0, $eCzHl.CellValueType).emojis:
                return this.emojis[parseInt(value, 16)] ?? value;
            case (0, $eCzHl.CellValueType).greekAlphabet:
                return this.greekAlphabet[parseInt(value, 16)] ?? value;
            default:
                return value;
        }
    }
    static getCanonicalValue(value, type) {
        let index;
        switch(type){
            case (0, $eCzHl.CellValueType).numbersOnly:
                index = this.numbersOnly.indexOf(value);
                break;
            case (0, $eCzHl.CellValueType).lettersOnly:
                index = this.lettersOnly.indexOf(value);
                break;
            case (0, $eCzHl.CellValueType).emojis:
                index = this.emojis.indexOf(value);
                break;
            case (0, $eCzHl.CellValueType).greekAlphabet:
                index = this.greekAlphabet.indexOf(value);
                break;
            default:
                return value;
        }
        if (index === -1) throw "Invalid";
        return this.standard[index];
    }
    static getPossibleValues(gameSize, type) {
        let values;
        switch(type){
            case (0, $eCzHl.CellValueType).numbersOnly:
                values = this.numbersOnly;
                break;
            case (0, $eCzHl.CellValueType).lettersOnly:
                values = this.lettersOnly;
                break;
            case (0, $eCzHl.CellValueType).emojis:
                values = this.emojis;
                break;
            case (0, $eCzHl.CellValueType).greekAlphabet:
                values = this.greekAlphabet;
                break;
            default:
                values = this.standard;
                break;
        }
        return values.slice(0, gameSize);
    }
}

});



var $ca3Iw = parcelRequire("ca3Iw");

var $8Ukbq = parcelRequire("8Ukbq");

var $jbRid = parcelRequire("jbRid");
const $c917f0401c058359$var$settingsService = (0, $ca3Iw.ComponentDependencyTree).settingsService;
document.addEventListener("DOMContentLoaded", async ()=>{
    let settings = await $c917f0401c058359$var$settingsService.getSettings();
    $c917f0401c058359$var$updateValuesInPage(settings.cellValueType);
    $c917f0401c058359$var$settingsService.onSettingsUpdated((newSettings)=>{
        settings = newSettings;
        $c917f0401c058359$var$updateValuesInPage(settings.cellValueType);
    });
    window.addEventListener("update-hex-values", ()=>{
        $c917f0401c058359$var$updateValuesInPage(settings.cellValueType);
    });
});
function $c917f0401c058359$var$updateValuesInPage(cellValueType) {
    for(let i = 0; i < 16; i++)for (const item of document.querySelectorAll(`.hex-value-${i}`)){
        const el = item;
        if (el instanceof (0, $8Ukbq.HexCell)) el.value = (0, $jbRid.HexakaiCellValueMapper).getValue(`${i}`, cellValueType);
        else el.innerText = (0, $jbRid.HexakaiCellValueMapper).getValue(`${i}`, cellValueType);
    }
}


//# sourceMappingURL=app.ed8457e3.js.map
